import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
} from "firebase/firestore";

export default function Admin() {
  const [imoveis, setImoveis] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [preco, setPreco] = useState("");
  const [imagem, setImagem] = useState("");
  const [localizacao, setLocalizacao] = useState("");
  const [metragem, setMetragem] = useState("");
  const [quartos, setQuartos] = useState("");
  const [banheiros, setBanheiros] = useState("");
  const [url, setUrl] = useState("");
  const [destaque, setDestaque] = useState(false);
  const [editando, setEditando] = useState(null);

  useEffect(() => {
    atualizarLista();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const novoImovel = {
      titulo,
      descricao,
      preco,
      imagem,
      localizacao,
      metragem,
      quartos,
      banheiros,
      url,
      destaque,
    };

    if (editando) {
      const imovelRef = doc(db, "imoveis", editando);
      await updateDoc(imovelRef, novoImovel);
      alert("Imóvel atualizado com sucesso!");
      setEditando(null);
    } else {
      await addDoc(collection(db, "imoveis"), novoImovel);
      alert("Imóvel cadastrado com sucesso!");
    }

    limparCampos();
    atualizarLista();
  };

  const handleEditar = (imovel) => {
    setTitulo(imovel.titulo);
    setDescricao(imovel.descricao);
    setPreco(imovel.preco);
    setImagem(imovel.imagem);
    setLocalizacao(imovel.localizacao);
    setMetragem(imovel.metragem);
    setQuartos(imovel.quartos);
    setBanheiros(imovel.banheiros);
    setUrl(imovel.url);
    setDestaque(imovel.destaque);
    setEditando(imovel.id);
  };

  const handleExcluir = async (id) => {
    if (window.confirm("Tem certeza que deseja excluir este imóvel?")) {
      await deleteDoc(doc(db, "imoveis", id));
      alert("Imóvel excluído com sucesso!");
      atualizarLista();
    }
  };

  const atualizarLista = async () => {
    const querySnapshot = await getDocs(collection(db, "imoveis"));
    const imoveisArray = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setImoveis(imoveisArray);
  };

  const limparCampos = () => {
    setTitulo("");
    setDescricao("");
    setPreco("");
    setImagem("");
    setLocalizacao("");
    setMetragem("");
    setQuartos("");
    setBanheiros("");
    setUrl("");
    setDestaque(false);
    setEditando(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto bg-white p-6 shadow-md rounded-md">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {editando ? "Editar Imóvel" : "Cadastrar Novo Imóvel"}
        </h2>

        {/* Formulário */}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          <input type="text" placeholder="Título do Imóvel" value={titulo} onChange={(e) => setTitulo(e.target.value)} className="p-2 border rounded-md" required />
          <textarea placeholder="Descrição" value={descricao} onChange={(e) => setDescricao(e.target.value)} className="p-2 border rounded-md" required />
          <input type="number" placeholder="Preço (R$)" value={preco} onChange={(e) => setPreco(e.target.value)} className="p-2 border rounded-md" required />
          <input type="text" placeholder="Imagem (URL)" value={imagem} onChange={(e) => setImagem(e.target.value)} className="p-2 border rounded-md" required />
          <input type="text" placeholder="Localização" value={localizacao} onChange={(e) => setLocalizacao(e.target.value)} className="p-2 border rounded-md" required />
          <input type="text" placeholder="Área (m²)" value={metragem} onChange={(e) => setMetragem(e.target.value)} className="p-2 border rounded-md" required />
          <input type="number" placeholder="Quartos" value={quartos} onChange={(e) => setQuartos(e.target.value)} className="p-2 border rounded-md" required />
          <input type="number" placeholder="Banheiros" value={banheiros} onChange={(e) => setBanheiros(e.target.value)} className="p-2 border rounded-md" required />
          <input type="text" placeholder="URL Saiba Mais" value={url} onChange={(e) => setUrl(e.target.value)} className="p-2 border rounded-md" required />
          
          <label className="flex items-center space-x-2">
            <input type="checkbox" checked={destaque} onChange={(e) => setDestaque(e.target.checked)} />
            <span>Marcar como Destaque</span>
          </label>
          
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-800 transition">
            {editando ? "Atualizar Imóvel" : "Cadastrar"}
          </button>
        </form>
      </div>

      {/* Lista de imóveis cadastrados */}
      <div className="max-w-4xl mx-auto mt-8">
        <h3 className="text-2xl font-bold mb-4">Imóveis Cadastrados</h3>
        {imoveis.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {imoveis.map((imovel) => (
              <div key={imovel.id} className="bg-white shadow-md p-4 rounded-md">
                <img src={imovel.imagem} alt={imovel.titulo} className="w-full h-40 object-cover rounded-md" />
                <h3 className="text-xl font-bold mt-2">{imovel.titulo}</h3>
                <p className="text-gray-600">{imovel.localizacao}</p>
                <p className="font-bold text-lg text-yellow-600 mt-2">R$ {imovel.preco}</p>
                <div className="flex justify-between mt-4">
                  <button onClick={() => handleEditar(imovel)} className="bg-yellow-500 text-white px-3 py-1 rounded-md">
                    Editar
                  </button>
                  <button onClick={() => handleExcluir(imovel.id)} className="bg-red-600 text-white px-3 py-1 rounded-md">
                    Excluir
                  </button>
                  <a href={`https://wa.me/5511994563626?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20${imovel.titulo}`} target="_blank" className="bg-green-500 text-white px-3 py-1 rounded-md">
                    Contato
                  </a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600 text-lg text-center">Nenhum imóvel cadastrado.</p>
        )}
      </div>
    </div>
  );
}
